(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
  var cart_btn = document.querySelector('.cart__submit');
  var total = document.querySelector('.cart-subtotal__price').dataset.cartSubtotal;
  var error_el = document.querySelector('.cart__error-message-wrapper');
  var error_msg = error_el.querySelector('.cart__error-message');

  cart_btn.addEventListener('click', function (e) {
    e.preventDefault();
    if (total < 2200) {
      cart_btn.disabled = true;
      error_el.classList.remove('hide');
      error_msg.innerText = 'Minimum order £22. Add more items to checkout.';
    } else {
      cart_btn.disabled = false;
      error_el.classList.remove('add');
      error_msg.innerText = '';
      window.location.href = '/checkout';
    }
  });

  } catch(e) { console.error(e); }
})();
})();
